<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">Select Relations</h3>
    </div>
  </div>
  <div class="card-body">
    <mat-form-field appearance="fill" class="w-100 mb-4">
      <mat-label>{{ 'DOCS_MODULE.DOCUMENT.ENTITY_TYPE' | translate }}</mat-label>
      <mat-select #entityTypeSelect multiple disabled>
        <mat-option *ngFor="let type of entityTypes" [value]="type">{{
          stringUtils.formatEnumString(type)
        }}</mat-option>
      </mat-select>
    </mat-form-field>
    <div class="w-100 mb-4">
      <kt-general-autocomplete
        #relationCategoryAutocomplete
        [label]="'DOCS_MODULE.DOCUMENT.RELATION_CATEGORIES' | translate"
        [chipList]="true"
        [dataPath]="'data'"
        [control]="relationCategoryAutocomplete"
        [objects]="relationCategoryAutocomplete.value"
        [loadItemsFunction]="getRelationCategoryAutocomplete"
        [optionFormatter]="formatRelationCategoryOption"
        [valueFormatter]="formatRelationCategoryOption"
        [formatNewObjectFn]="formatNewRelationCategory"
        [change]="handleRelationCategoryChange.bind(this)"
        [readOnly]="false"
      ></kt-general-autocomplete>
    </div>
    <div class="w-100">
      <kt-general-autocomplete
        #relationTypeAutocomplete
        [label]="'DOCS_MODULE.DOCUMENT.RELATION_TYPES' | translate"
        [chipList]="true"
        [dataPath]="'data'"
        [control]="relationTypeAutocomplete"
        [objects]="relationTypeAutocomplete.value"
        [loadItemsFunction]="getRelationTypeAutocomplete"
        [optionFormatter]="formatRelationTypeOption"
        [valueFormatter]="formatRelationTypeOption"
        [formatNewObjectFn]="formatNewRelationType"
        [readOnly]="!relationCategoryAutocomplete.value?.length"
      ></kt-general-autocomplete>
    </div>
  </div>
  <div class="card-footer d-flex justify-content-end">
    <button
      mat-raised-button
      cdkFocusInitial
      style="width: 100px !important"
      class="btn btn-sm btn-light"
      (click)="closeDialog($event)"
    >
      {{ 'GLOBAL.CANCEL' | translate }}
    </button>
    <button
      mat-raised-button
      style="width: 100px !important"
      class="btn btn-sm btn-primary ml-4"
      (click)="submit($event)"
    >
      {{ 'GLOBAL.SAVE' | translate }}
    </button>
  </div>
</div>
